import { render } from "./Item.vue?vue&type=template&id=75bc2878&ts=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
